export default {"src":"/_next/static/media/CRSR.7ce9d964.svg","height":18,"width":18};